import React,{
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./CurrentLevelCard.css";

import{

    ShieldCheck,

    Trophy

} from "lucide-react";

const CurrentLevelCard = ()=>{

    const email=
    localStorage.getItem(
        "user_email"
    );

    const[level,setLevel]=
    useState(1);

    const[progress,setProgress]=
    useState(0);

    useEffect(()=>{

        loadJourney();

    },[]);

    const loadJourney=async()=>{

        try{

            const res=
            await axios.get(

                `/api/ignite/journey/${email}`

            );

            setLevel(

                res.data.levelObjectives.currentLevel

            );

            setProgress(

                res.data.levelObjectives.progress

            );

        }

        catch(err){

            console.error(err);

        }

    };

    const levelNames={

        1:"ROOKIE",

        2:"CONTENDER",

        3:"PERFORMER",

        4:"ELITE"

    };

    return(

        <div className="current-level-card">

            <div className="current-header">

                <div>

                    <h3>

                        Current Level

                    </h3>

                    <p>

                        Your current Ignite stage.

                    </p>

                </div>

                <ShieldCheck
                    size={30}
                />

            </div>

            <div className="current-level-number">

                Level {level}

            </div>

            <div className="current-level-name">

                <Trophy
                    size={18}
                />

                {levelNames[level]}

            </div>

            <div className="current-progress">

                <div className="current-progress-bar">

                    <div

                        className="current-progress-fill"

                        style={{

                            width:

                            `${progress}%`

                        }}

                    />

                </div>

            </div>

            <div className="current-progress-text">

                {progress}% Completed

            </div>

        </div>

    );

};

export default CurrentLevelCard;